import Chart from "../../components/Chart.tsx";
import { useJournalStatisticsContext } from "../../contexts/journalStatistics.tsx";
import { Color } from "../../models/helpers/colors.ts";
const JournalStatisticsBody = () => {
    const { days } = useJournalStatisticsContext();

    const chartData = days
        .sort((a, b) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime())
        .map(entry => ({
            name: entry.dateTime.getDate(),
            calories: Math.round(entry.calories),
            protein: Math.round(entry.protein),
            carbs: Math.round(entry.carbohydrates),
            fat: Math.round(entry.totalFat),
        }));

    if (chartData.length > 100) {
        const groupedByMonth: { [key: number]: { calories: number; protein: number; carbs: number; fat: number; count: number } } = {};

        days.forEach(entry => {
            const monthKey = entry.dateTime.getMonth() + 1;
            if (!groupedByMonth[monthKey]) {
                groupedByMonth[monthKey] = {
                    calories: 0,
                    protein: 0,
                    carbs: 0,
                    fat: 0,
                    count: 0
                };
            }
            var exists = (entry.calories > 0 || entry.protein > 0 || entry.carbohydrates > 0 || entry.totalFat > 0);
            groupedByMonth[monthKey].calories += entry.calories;
            groupedByMonth[monthKey].protein += entry.protein;
            groupedByMonth[monthKey].carbs += entry.carbohydrates;
            groupedByMonth[monthKey].fat += entry.totalFat;
            groupedByMonth[monthKey].count += exists ? 1 : 0;
        });

        chartData.length = 0;
        for (const key in groupedByMonth) {
            const avg = groupedByMonth[key];
            chartData.push({
                name: parseInt(key),
                calories: Math.round(avg.calories / avg.count),
                protein: Math.round(avg.protein / avg.count),
                carbs: Math.round(avg.carbs / avg.count),
                fat: Math.round(avg.fat / avg.count)
            });
        }
    }

    return (
        <div className="w-max h-max" 
        style={{marginLeft:"-10px"}}
        >
            <Chart
                data={chartData}
                XAxisDataKey="name"
                syncID="statistics"
                areas={[{ dataKey: 'calories', stroke: Color.success }]}
            />
            <Chart
                data={chartData}
                XAxisDataKey="name"
                syncID="statistics"
                areas={[{ dataKey: 'protein', stroke: Color.success }]}
            />
            <Chart
                data={chartData}
                XAxisDataKey="name"
                syncID="statistics"
                areas={[{ dataKey: 'carbs', stroke: Color.warning }]}
            />
            <Chart
                data={chartData}
                XAxisDataKey="name"
                syncID="statistics"
                areas={[{ dataKey: 'fat', stroke: Color.danger }]}
            />
        </div>
    );
};

export default JournalStatisticsBody;
